import { Image, Stack } from '@chakra-ui/react'
import ImageBox from 'components/common/ImageBox'
import { ProductFormulaSectionItem } from 'components/sections/ProductFormulaSection/index'
import { Body1, Body1Strong, H2 } from 'components/typography'
import { FC } from 'react'

export const ProductFormulaCard: FC<ProductFormulaSectionItem> = (props) => {
  return (
    <Stack p="5" bg="grayscale.20" rounded="32px">
      {props.img
        ? props.img
        : props.imgSrc && (
            <ImageBox
              alt="substância"
              src={props.imgSrc}
              w="52px"
              h="52px"
              rounded="full"
              borderWidth="2px"
              borderColor="phthalo"
            />
          )}
      <Stack flex={1}>
        {props.title && (
          <H2 fontSize="3xl" fontWeight="800">
            {props.title}
          </H2>
        )}
        {props.subtitle && <Body1Strong fontWeight="800">{props.subtitle}</Body1Strong>}
        {props.description && <Body1>{props.description}</Body1>}
      </Stack>
    </Stack>
  )
}
